import React, { useState } from 'react';
import { MarketplaceHeader } from '../components/layout/MarketplaceHeader';
import { Footer } from '../components/layout/Footer';
import { RestaurantCard } from '../components/marketplace/RestaurantCard';
import { useMarketplaceData, useRestaurants } from '../lib/hooks';
import { Skeleton } from '../components/ui/Skeleton';
import { EmptyState } from '../components/ui/EmptyState';
import { Store, Search, MapPin, Filter } from 'lucide-react';
import { useLanguage } from '../lib/i18n';
export function RestaurantListingPage() {
  const {
    categories,
    zones,
    loading: marketplaceLoading
  } = useMarketplaceData();
  const [filters, setFilters] = useState({
    zoneId: '',
    categoryId: '',
    search: ''
  });
  const {
    restaurants,
    loading: restaurantsLoading
  } = useRestaurants(filters);
  const {
    t
  } = useLanguage();
  const handleFilterChange = (key: keyof typeof filters, value: string) => {
    setFilters(prev => ({
      ...prev,
      [key]: value
    }));
  };
  return <div className="min-h-screen w-full flex flex-col bg-[#0B0B0B]" data-id="element-6222">
      <MarketplaceHeader data-id="element-6223" />

      <main className="flex-1" data-id="element-6224">
        <div className="border-b border-white/5 py-8" data-id="element-6225">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-6226">
            <h1 className="text-3xl font-bold text-white mb-6" data-id="element-6227">
              {t('explore')}
            </h1>

            {/* Filters Bar */}
            <div className="flex flex-col md:flex-row gap-4" data-id="element-6228">
              {/* Search */}
              <div className="flex-1 relative" data-id="element-6229">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" data-id="element-6230" />
                <input type="text" placeholder={t('search_placeholder')} value={filters.search} onChange={e => handleFilterChange('search', e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-xl border border-white/10 bg-[#141414] text-white placeholder-white/30 focus:outline-none focus:ring-2 focus:ring-[#C9A34E]/50 focus:border-[#C9A34E]/30 transition-shadow" data-id="element-6231" />
              </div>

              {/* Zone Filter */}
              <div className="w-full md:w-64 relative" data-id="element-6232">
                <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" data-id="element-6233" />
                <select value={filters.zoneId} onChange={e => handleFilterChange('zoneId', e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-xl border border-white/10 bg-[#141414] text-white focus:outline-none focus:ring-2 focus:ring-[#C9A34E]/50 appearance-none cursor-pointer" data-id="element-6234">
                  <option value="" data-id="element-6235">{t('all_zones')}</option>
                  {zones.filter(zone => !['dota', 'leon-cortes'].includes(zone.slug)).map(zone => <option key={zone.id} value={zone.slug} data-id="element-6236">
                        {zone.name}
                      </option>)}
                </select>
              </div>

              {/* Category Filter */}
              <div className="w-full md:w-64 relative" data-id="element-6237">
                <Filter className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-white/30" data-id="element-6238" />
                <select value={filters.categoryId} onChange={e => handleFilterChange('categoryId', e.target.value)} className="w-full pl-10 pr-4 py-3 rounded-xl border border-white/10 bg-[#141414] text-white focus:outline-none focus:ring-2 focus:ring-[#C9A34E]/50 appearance-none cursor-pointer" data-id="element-6239">
                  <option value="" data-id="element-6240">{t('all_categories')}</option>
                  {categories.map(category => <option key={category.id} value={category.id} data-id="element-6241">
                      {category.name}
                    </option>)}
                </select>
              </div>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto py-12 px-4 sm:px-6 lg:px-8" data-id="element-6242">
          {restaurantsLoading || marketplaceLoading ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6243">
              {[1, 2, 3, 4, 5, 6].map(i => <Skeleton key={i} variant="card" className="h-[320px]" data-id="element-6244" />)}
            </div> : restaurants.length > 0 ? <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-6245">
              {restaurants.map(restaurant => <RestaurantCard key={restaurant.id} restaurant={restaurant} zoneName={zones.find(z => z.id === restaurant.zone_id)?.name} data-id="element-6246" />)}
            </div> : <div className="py-12" data-id="element-6247">
              <EmptyState icon={Store} title={t('no_restaurants')} description={t('no_restaurants_desc')} actionLabel={t('clear_filters')} onAction={() => setFilters({
            zoneId: '',
            categoryId: '',
            search: ''
          })} data-id="element-6248" />
            </div>}
        </div>
      </main>

      <Footer data-id="element-6249" />
    </div>;
}